<div class="main-container" style="height: 100%;">

    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">

        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="dark-sidebar afiliado-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" [(opened)]="opened" style="width: 280px !important;">
            <app-nuevo-side></app-nuevo-side>
        </mat-sidenav>

        <mat-sidenav-content class="page-wrapper">
            <mat-toolbar class="afiliado-topbar">
                <button id="snavButton" mat-icon-button (click)="snav.toggle()" value="sidebarclosed" class="afiliado-topbar__menu-btn">
                    <mat-icon>{{ opened ? 'menu_open' : 'menu' }}</mat-icon>
                </button>

                <span class="afiliado-topbar__title">{{nombreEmpresa}}</span>

                <span fxFlex></span>

                <app-navbar></app-navbar>
            </mat-toolbar>
            <!-- ============================================================== -->
            <!-- Page container - style you can find in pages.scss -->
            <!-- ============================================================== -->
            <div class="page-content">
                <router-outlet>
                    <app-spinner></app-spinner>
                </router-outlet>

            </div>

        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>